import requstHelper from './requstHelper';
import store from '../store';
import { getUrlParam, getToken } from '../utils/index';

class serviceApi {
  // 默认构造函数
  constructor() {
    return this;
  }
  // 账号密码登录
  static login = params => requstHelper.fetch('/sys/login', params, {
    header: {
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })
  // 企业微信扫码
  static userLogin = params => requstHelper.fetch('/enterpriseWeChatLogin', params, {
    header: {
      'yxj-encrypt': 'yes_mis',
    },
    method: 'GET',
  })

  static getLoginRoleList = params => requstHelper.fetch(`selectRoleList/${params.id}`, {}, {
    header: {},
    method: 'GET',
  })

  // 短信验证码登录
  static codeLogin = params => requstHelper.fetch('sys/mlogin', params, {
    header: {
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取短信验证码
  static getCode = params => requstHelper.fetch('getVerificationCode', params, {
    header: {
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 修改密码
  static updatePwd = params => requstHelper.fetch('sys/user/password', params, {
    header: {
      encrypt: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })
  static roleCommit = params => requstHelper.fetch('sys/user/commit', params, {
    header: {
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取用户菜单按钮权限
  static getMenuAndButton = params => requstHelper.fetch('sys/menu/nav', params, {
    header: {
      encrypt: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取角色列表
  static getRoleList = params => requstHelper.fetch('sys/role/list', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取用户菜单按钮权限用于分配角色
  static getRoleTree = params => requstHelper.fetch('sys/menu/navButton', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })


  // 添加角色
  static insertRole = params => requstHelper.fetch('sys/role/save', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 修改角色
  static updateRole = params => requstHelper.fetch('sys/role/update', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 通过角色Id获取角色
  static getRoleById = params => requstHelper.fetch('sys/role/info', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 删除角色
  static deleteRole = params => requstHelper.fetch('sys/role/delete', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取账户列表
  static getUserList = params => requstHelper.fetch('sys/user/list', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 删除账号
  static deleteUserById = params => requstHelper.fetch('sys/user/delete', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 锁定用户
  static lockUser = params => requstHelper.fetch('sys/user/lock', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取所有角色 (不分页)
  static getAllRoleList = params => requstHelper.fetch('sys/role/select', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 通过userId获取用户
  static getUserById = params => requstHelper.fetch('sys/user/info', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 添加用户
  static insertUser = params => requstHelper.fetch('sys/user/save', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 修改用户
  static updateUser = params => requstHelper.fetch('sys/user/update', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取专家列表
  static getExpertList = params => requstHelper.fetch('user/expertList', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 删除专家
  static delExpert = params => requstHelper.fetch('user/delExpert', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 添加专家
  static insertExpert = params => requstHelper.fetch('user/expertInsert', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 修改专家
  static updateExpert = params => requstHelper.fetch('user/expertUpdate', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取普通医生列表
  static getOrdinaryList = params => requstHelper.fetch('user/doctorlist', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 通过code获取普通医生详情
  static getOrdinaryByCode = params => requstHelper.fetch('user/doctorDetail', params, {
    header: {
      token: getToken('token'),
    },
    method: 'GET',
  })

  // 普通医生认证
  static confirmDoctor = params => requstHelper.fetch('user/update', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取目标医生列表
  static getTargetList = params => requstHelper.fetch('user/list', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 获取病例列表
  static getCaseList = params => requstHelper.fetch('case/collect/list', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 通过code获取病例
  static getCaseByCode = params => requstHelper.fetch('case/collect/detail', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 病例审核
  static examineCase = params => requstHelper.fetch('case/collect/audit', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 推荐和取消推荐
  static recommendCase = params => requstHelper.fetch('case/collect/push', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 退出登录
  static goOut = params => requstHelper.fetch('sys/logout', params, {
    header: {
      token: getToken('token'),
      encrypt: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 批量推荐
  static patchPush = params => requstHelper.fetch('case/collect/pushList', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 普通医生导出
  static downloadOrdinary = params => requstHelper.fetch('excel/exportExcel', params, {
    header: {
      token: getToken('token'),
    },
    method: 'GET',
  })

  // 病例导出
  static downloadCase = params => requstHelper.fetch('excel/exportExcel', params, {
    header: {
      token: getToken('token'),
    },
    method: 'GET',
  })

  // 重置密码
  static resetPassword = params => requstHelper.fetch('sys/user/resetPassword', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 大会分会保存
  static conventionBranchSave = params => requstHelper.fetch('conventionBranch/save', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })
  // 大会分会编辑
  static conventionBranchUpdate = params => requstHelper.fetch('conventionBranch/update', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 编辑搜索热词
  static labelHotSearchUpdate = params => requstHelper.fetch('labelHotSearch/update', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 关联内容添加
  static contentRelationSave = params => requstHelper.fetch('contentRelation/save', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 查询患者绑定的医生列表接口
  static searchDoctorList = params => requstHelper.fetch('userBase/doctorList', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 查询患者绑定的医生列表接口
  static searchGlksList = params => requstHelper.fetch('departmentRelation/list', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 搜索热词添加
  static labelHotSearchSave = params => requstHelper.fetch('labelHotSearch/save', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })

  // 关联科室添加
  static departmentRelationSave = params => requstHelper.fetch('departmentRelation/save', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })
  // 关联科室添加
  static departmentRelationEdit = params => requstHelper.fetch('departmentRelation/edit', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })
  // 关联科室排序
  static departmentRelationSort = params => requstHelper.fetch('departmentRelation/sort', params, {
    header: {
      token: getToken('token'),
      'yxj-encrypt': 'yes_mis',
    },
    method: 'POST',
  })
  

  // 获取公司logo
  static getCompanyLogo = (params) => {
    const myParams = params;
    return requstHelper.fetch('query/company/detail', myParams, {
      header: {
        token: getUrlParam('token'),
      },
      method: 'GET',
    });
  }

  // 获取新消息通知
  static getNewMsg = (params) => {
    const myParams = params;
    const userInfo = store.getters['user/userInfo'](myParams.companyCode);
    return requstHelper.fetch('message/msg/new', {}, {
      header: {
        token: userInfo.token,
      },
      method: 'GET',
    });
  }

  
  // 订单管理列表
  static ordersBuy = (params) => {
    const myParams = params;
    const userInfo = store.getters['user/userInfo'];
    myParams.companyCode = userInfo.companyCode;
    return requstHelper.fetch('trade/orders/buy', myParams, {
      header: {
        token: getUrlParam('token'),
        'yxj-encrypt': 'yes_mis',
      },
      method: 'POST',
    });
  }

  // 转换key值，部分接口不支持json
  static stringify = (param) => {
    const query = [];
    Object.keys(param).forEach((key) => {
      query.push(`${key}=${param[key]}`);
    });
    return query.join('&');
  }
}

export default serviceApi;



// WEBPACK FOOTER //
// ./src/api/serviceAPI.js